import firebase from 'firebase'

const firebaseConfig =   {
  apiKey: "AIzaSyB_EGrW4LOatpb8vazre3l2VhM6CMHWiP4",
  authDomain: "tabela-interclasse.firebaseapp.com",
  projectId: "tabela-interclasse",
  storageBucket: "tabela-interclasse.appspot.com",
  messagingSenderId: "972690376238",
  appId: "1:972690376238:web:5565c520a4d9e5d6c9c1bf",
  measurementId: "G-072E3TQ4L8"
  };

  export const $firebase = firebase.initializeApp(firebaseConfig);

  export const db = $firebase.firestore()
